import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { App } from '../../../App';
import { SmartContainer, Surface } from '../../../styles/Containers';
import { StyledButton } from '../../../styles/matieralui/Button';
import { RevisionSelector } from '../../../components/Publishing/RevisionSelector';
import { FullScreenLoader } from '../../../components/Loaders/FullScreenLoader';
import { FullViews } from './redux/views.selectors';
import { useActiveItem } from '../../services/CaptureCollabService';
import { getView } from './redux/views.actions';
import { EditViewForm } from './EditViewForm';
export const PageViewSettings = () => {


    // New Modal
    const dispatch = useDispatch();
    const store = FullViews();
    const { id } = useParams();
    const [trigger, setTrigger] = useState('resting');
    const { activeItem, setActiveItem } = useActiveItem({ id, model: 'View', selector: FullViews, getAction: getView })

    const triggerSave = () => {
        setTrigger('save');
        setTimeout(() => setTrigger('resting'), 2000)
    }

    const renderTopBarChildren = () => {

        return (
            <SmartContainer flex align="center" justify="flex-end">
                <StyledButton variant='contained' onClick={triggerSave} color="blue">Save</StyledButton>
            </SmartContainer>
        )

    }

    const handleRevisionChange = (revision) => {

        // Clear Revision
        if (!revision) setActiveItem(store.activeItem);
        else {
            const mergedData = { ...revision.fields, id: revision.modelId }
            setActiveItem(mergedData);
        }
    }


    // Render Page
    return (
        <App title="Edit View" topBarChildren={renderTopBarChildren()} breadcrumbs={[{ href: `/views`, title: 'Views' }, { href: `/views/${id}`, title: 'This View' }]}>
            {store?.activeItemLoading && (<FullScreenLoader />)}
            {!store?.activeItemLoading && (
                <SmartContainer thinking={store?.deleteLoading || store?.updateLoading}>
                    <EditViewForm
                        item={activeItem}
                        trigger={trigger}
                    />
                </SmartContainer>
            )}
        </App>
    )
}